module.exports = __webpack_public_path__ + "img/krista.727bc22e.png";